import { HttpPostFunction } from "@lookiero/sty-psp-http";
import {
  IsCategoriesOfferingEnabledView,
  ViewIsCategoriesOfferingEnabledResult,
} from "../../../projection/offering/viewIsCategoriesOfferingEnabled";

interface ViewIsCategoriesOfferingEnabledResponse {
  readonly active: boolean;
}

interface HttpCategoriesOfferingEnabledView extends IsCategoriesOfferingEnabledView {}

interface HttpCategoriesOfferingEnabledViewFunctionArgs {
  readonly httpPost: HttpPostFunction;
}

interface HttpCategoriesOfferingEnabledViewFunction {
  (args: HttpCategoriesOfferingEnabledViewFunctionArgs): HttpCategoriesOfferingEnabledView;
}

const httpCategoriesOfferingEnabledView: HttpCategoriesOfferingEnabledViewFunction =
  ({ httpPost }) =>
  async ({ signal }) =>
    await httpPost<ViewIsCategoriesOfferingEnabledResponse, ViewIsCategoriesOfferingEnabledResult>({
      endpoint: "/categories/v2/has-access",
      body: {},
      signal,
      result: {
        error: false,
        success: (response) => response?.active ?? false,
      },
    });

export { httpCategoriesOfferingEnabledView };
